<div class="application-menu-wrapper" soho-busyindicator blockUI="true" displayDelay="-1">
    <div class="application-menu-header expandable-area-header" [ngClass]="{'lm-do-not-apply-color': !applyColorToMenu }">

        <svg *ngIf="noActorUrl()" class="icon avatar" viewBox="0 0 48 48" focusable="false" aria-hidden="true" role="presentation">
            <use xlink:href="#icon-user-avatar"></use>
        </svg>
        <img *ngIf="!noActorUrl()" class="icon avatar" [src]="actorUrl" alt=""/>
        <!-- decorative image, alt can be left blank since there's an actorName span below -->
        <ng-container *ngIf="(roleSwitcher && filteredWebAppSpecs.length > 0) || (menuItemSpecs && filteredWebAppSpecs.length > noCasualApps)">
            <button type="button" class="btn application-menu-switcher-trigger expandable-area-trigger hide-focus" soho-tooltip title="{{ webAppTitle }}" id="{{webAppSwitcherButtonId}}">
                <span class="web-app-title">{{ webAppTitle }}</span>
                <svg class="icon icon-closed" focusable="false" aria-hidden="true" role="presentation">
                    <use xlink:href="#icon-caret-down"></use>
                </svg>
                <svg class="icon icon-opened" focusable="false" aria-hidden="true" role="presentation">
                    <use xlink:href="#icon-caret-up"></use>
                </svg>
            </button>
            <div class="expandable-area" aria-expanded="false" aria-controls="expandable-area-0-content" id="expandable-area-0-header">
                <div class="expandable-pane application-menu-switcher-panel" id="expandable-area-0-content" style="height: 0px; display: none;" attr.aria-label="{{'AppMenuSwitcherSection' | translate}}">
                    <div class="content" style="height: 651.4px;">
                        <div class="accordion panel inverse">
                            <div *ngFor="let menuItem of filteredWebAppSpecs" class="accordion-header hide-focus">
                                <a href="#"
                                   (click)="onSelectRole($event)"
                                   (contextmenu)="onRoleRightClick($event, menuItem)"
                                   attr.web-app-name="{{menuItem.webAppName}}"
                                   attr.navigation-menu-url="{{menuItem?.navigationMenuUrl || menuItem?.link}}"
                                   attr.id="{{webAppId(menuItem.webAppName)}}"
                                   title="{{menuItem?.webAppTitle || menuItem?.name}}"
                                ><span>{{menuItem?.webAppTitle || menuItem?.name}}</span></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
        <span class="name-xl">{{actorName}}</span>

        <div class="application-menu-toolbar">
            <div class="flex-toolbar">
                <div class="toolbar-section buttonset center-text">

                    <ng-container *ngFor="let button of applicationMenuButtons" >
                        <button *ngIf="button.url"
                                soho-button="icon"
                                id="{{button.id}}"
                                (click)="openLink(button.url)"
                                [icon]="button.icon"
                                soho-tooltip [content]="button.label"
                        >
                            {{ button.label }}
                        </button>
                        <span *ngIf="button.id === 'MyNotifications_button'" [ngClass]="{'red-dot' : displayRedDot }"></span>
                    </ng-container>
                    <ng-container *ngIf="showOverFlowMenuButton">
                        <button soho-button="icon"
                                id="lm-banner-nav-menu-settings-btn"
                                data-automation-id="lm-appmenu-settings-menu-button"
                                class="lm-banner-nav-menu-settings-btn"
                                soho-tooltip content="{{ 'More' | translate }}"
                                [icon]="'more'"
                                (click)="onToggleActionMenu($event)">
                        </button>

                        <div #ActionMenu
                             id="lm-banner-nav-action-menu"
                             data-automation-id="lm-appmenu-settings-menu"
                             class="lm-banner-nav-action-menu popupmenu-wrapper bottom"
                        >
                            <div class="arrow"></div>
                            <ul class="popupmenu has-icons">
                                <ng-container *ngFor="let button of myOverflowMenuButtons" >
                                    <li id="{{button.id}}" (click)="openLink(button.url)" (click)="closeActionMenu()">
                                        <a href="javascript:void(0);" role="menuitem" tabindex="-1"
                                           attr.data-automation-id="{{button.id}}"
                                        >
                                            <svg *ngIf="button.icon" soho-icon icon="{{button.icon}}"></svg>
                                            {{button.label}}
                                        </a>
                                    </li>
                                </ng-container>
                            </ul>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>

    </div>

    <div class="application-menu-content">
        <ng-container *ngIf="isPasswordReset">
            <div class="accordion panel inverse">
                <div class="accordion-header"><a><span>{{ 'ResetPassword' | translate }}</span></a></div>
            </div>
        </ng-container>

        <ng-container *ngIf="!isPasswordReset">
            <!-- MENU SEARCH FIELD -->
            <div *ngIf="showSearch" soho-searchfield-wrapper>
                <label class="audible" for="application-menu-searchfield">{{ 'Search' | translate }}</label>
                <input #SearchField
                       id="application-menu-searchfield"
                       soho-toolbar-searchfield
                       placeholder="{{ 'Search' | translate }}"
                       [(ngModel)]="model.searchFieldValue"
                       [collapsibleOnMobile]="true"
                       [clearable]="true"
                       (ngModelChange)="autoSearchMenu($event)"
                       (keydown.enter)="fireMenuSearchEvent($event)"
                       (cleared)="fireClearSearchEvent($event)"
                />
            </div>
            <div class="accordion panel inverse" data-options="{'allowOnePane': 'true', 'rerouteOnLinkClick': 'false'}">
                <ng-container *ngIf="appSwitcher === 'casual'">
                    <ng-container *ngIf="menuItemSpecs">
                        <ng-container *ngIf="filteredWebAppSpecs.length === 0 || this.roleSwitcher">
                            <lm-application-menu-submenu [menuItemSpecs]="menuItemSpecs" (menuLoaded)="onMenuLoaded($event)"></lm-application-menu-submenu>
                        </ng-container>
                        <ng-container *ngIf="filteredWebAppSpecs.length > 0 && !this.roleSwitcher">
                            <div #webAppMenuHeader attr.id="{{webAppName}}" class="accordion-header">
                                <svg soho-icon icon="user"></svg>
                                <a href="#"
                                   attr.web-app-name="{{webAppName}}"
                                   attr.navigationmenuurl="{{webAppMenuNavigationUrl}}"
                                   attr.id="{{webAppName}}"><span>{{webAppTitle || webAppName}}</span>
                                </a>
                            </div>
                            <lm-application-menu-submenu class="accordion-pane has-icons" [menuItemSpecs]="selectMenuSpec(webAppName) || menuItemSpecs" (menuLoaded)="onMenuLoaded($event)"></lm-application-menu-submenu>
                            <ng-container *ngFor="let menuItem of filteredWebAppSpecs">
                                <div attr.id="{{menuItem.webAppName}}" class="accordion-header">
                                    <svg soho-icon icon="folder"></svg>
                                    <a href="#"
                                       attr.web-app-name="{{menuItem.webAppName}}"
                                       attr.navigationmenuurl="{{menuItem?.navigationMenuUrl || menuItem?.link}}"
                                       title="{{menuItem?.webAppTitle || menuItem?.name}}"
                                       attr.id="{{menuItem.webAppName}}"
                                    ><span>{{menuItem?.webAppTitle || menuItem?.name}}</span></a>
                                </div>
                                <lm-application-menu-submenu class="accordion-pane has-icons" [menuItemSpecs]="selectMenuSpec(menuItem.webAppName)" (menuLoaded)="onMenuLoaded($event)"></lm-application-menu-submenu>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </ng-container>
                <div *ngIf="showProxy" class="accordion-header">
                    <a (click)="openProxyPage()" href="#" class="hyperlink"><span>{{ 'Proxy' | translate }}</span></a>
                </div>
                <div *ngIf="enableUserContextMenu" class="accordion-header"><a href="#" (click)="openSetUserContextDialog()"><span>{{ 'ActorContextMenuLabel' | translate }}</span></a></div>
                <div *ngIf="createReportUrl" class="accordion-header"><a href="#" (click)="runCreateReport()"><span>{{ 'CreateReport' | translate }}</span></a></div>
                <div *ngIf="allowSetAsOfDate" class="accordion-header"><a href="#" (click)="openSetAsOfDateDialog()"><span>{{ 'AsOfDateLabel' | translate }}</span></a></div>
            </div>
        </ng-container>
    </div>

    <div class="application-menu-footer" [ngClass]="{'lm-do-not-apply-color': !applyColorToMenu }">
        <div class="application-menu-toolbar">
            <div class="flex-toolbar">
                <div class="toolbar-section buttonset">

                    <ng-container *ngIf="!anonymousUser && !isPasswordReset">
                        <!--
                        SETTINGS BUTTON
                        -->
                        <button *ngIf="!hasChangePasswordLink"
                                soho-button="btn" type="button" id="Settings_button" class="btn l-pull-left"
                                (click)="openUserSettingsDialog()"
                                [icon]="'settings'"
                                soho-tooltip content="{{ 'Settings' | translate }}"
                        >{{ 'Settings' | translate }}</button>

                        <!--
                        CHANGE PASSWORD BUTTON
                        -->
                        <button *ngIf="hasChangePasswordLink"
                                soho-button="btn" type="button" id="ChangePassword_button" class="btn l-pull-left"
                                (click)="openChangePasswordWindow()"
                                soho-tooltip content="{{ 'ChangePassword' | translate }}"
                        >{{ 'ChangePassword' | translate }}</button>

                        <!--
                        ABOUT BUTTON
                        -->
                        <button *ngIf="!hasChangePasswordLink"
                                soho-button="icon" type="button" class="btn" id="About_button"
                                soho-tooltip content="{{ 'About' | translate }}"
                                title="{{ 'About' | translate }}"
                                (click)="openLink(aboutLink)"
                                [icon]="'info-linear'"
                        >{{ 'About' | translate }}</button>

                        <!--
                        HELP BUTTON
                        -->
                        <button *ngIf="appHelpLink && !hasChangePasswordLink"
                                soho-button="icon" type="button" class="btn" id="Help_button"
                                (click)="openHelpLink()"
                                [icon]="'help'"
                                soho-tooltip content="{{ 'Help' | translate }}"
                        >{{ 'Help' | translate }}</button>

                        <!--
                        LOGOUT BUTTON
                        -->
                        <button *ngIf="!mingleMode && !insideInforGo"
                                soho-button="icon" type="button" [ngClass]="{'btn l-pull-right' : hasChangePasswordLink }" id="Logout_button"
                                (click)="openSecurityLink(signOutLink)"
                                [icon]="'logout'"
                                soho-tooltip content="{{ 'Logout' | translate }}"
                        >{{ 'Logout' | translate }}</button>

                    </ng-container>

                    <ng-container *ngIf="!anonymousUser && isPasswordReset">
                        <!--
                        LOGOUT BUTTON
                        -->
                        <button *ngIf="!mingleMode && !insideInforGo"
                                soho-button="btn" type="button" class="btn l-pull-left" id="Logout_button2"
                                (click)="openSecurityLink(signOutLink)"
                                [icon]="'logout'"
                                soho-tooltip content="{{ 'Logout' | translate }}"
                        >{{ 'Logout' | translate }}</button>

                    </ng-container>

                    <ng-container *ngIf="anonymousUser">

                        <!--
                        SIGN-IN BUTTON
                        -->
                        <button *ngIf="clientLogin"
                                soho-button="btn" type="button" class="btn l-pull-left" id="ClientLoginSignIn_button"
                                (click)="openLoginWindow()"
                                soho-tooltip content="{{ 'SignIn' | translate }}"
                        >{{ 'SignIn' | translate }}</button>

                        <!--
                        SIGN-IN BUTTON
                        -->
                        <button *ngIf="!clientLogin"
                                soho-button="btn" type="button" class="btn l-pull-left" id="SignIn_button"
                                (click)="openSecurityLink(signInLink)"
                                soho-tooltip content="{{ 'SignIn' | translate }}"
                        >{{ 'SignIn' | translate }}</button>

                        <!--
                        REGISTER BUTTON
                        -->
                        <button *ngIf="hasRegisterLink"
                                soho-button="btn" type="button" class="btn l-pull-right" id="Register_button"
                                (click)="openLink(registerLink)"
                                soho-tooltip content="{{ 'Register' | translate }}"
                        >{{ 'Register' | translate }}</button>
                    </ng-container>

                </div>
            </div>
        </div>
    </div>

    <div #UserSettingsDialog>
        <!-- dialog placeholder used to display user settings -->
    </div>

    <div #LoginDialog>
        <!-- dialog placeholder used to display login screen -->
    </div>

    <div #AccessDeniedDialog>
        <!-- dialog placeholder used to display access denied error -->
    </div>

    <div #ChangePasswordDialog>
        <!-- dialog placeholder used to display change password screen -->
    </div>

    <div #DrillbackActionFormDialog>
        <!-- dialog placeholder used to display a drillback for an action form -->
    </div>

    <div #ReportPersonalizationDialog>
    <!-- dialog placeholder used to display a report personalization dialog -->
    </div>

    <div #SetAsOfDateDialog>
        <!-- dialog placeholder used to display Set As of Date dialog -->
    </div>

    <div #UserContextDialog>
        <!-- dialog placeholder used to display User Context dialog -->
    </div>

    <div #menuFormDialog>
        <!-- dialog placeholder used to display action form from menu -->
    </div>
</div>